/*
Licensed users sit beside device licences. A null cap means the
institution is not on a user limit. Do not invent a number.
*/

export const licenseLines = (license) => {
  const active = Number(license?.activeUsers)
  const activeUsers = Number.isFinite(active) && active > 0 ? active : 0
  const devices = license?.maxDeviceLicenses ?? 0
  const cap = license?.licensedUsers
  const lines = []
  if (cap == null || cap === '') {
    lines.push(`Active users: ${activeUsers}`)
    lines.push('No user cap set')
  } else {
    lines.push(`Licensed users included: ${cap}`)
    lines.push(`Active users: ${activeUsers}`)
  }
  lines.push(`Device licences: ${devices}`)
  return lines
}
